import { createContext } from 'react'

import { NavContextType } from './nav-types'

export const NavContext = createContext<NavContextType>({} as NavContextType)
